import {useNavigate} from "react-router-dom";
import {
  generateTablesAndFigures,
  formatMenus,
} from "../tablesAndFiguresMenuGenerator";
import { useSelector } from "react-redux";
import { selectMap } from "../../../features/counter/counterSlice";
import { useEffect, useMemo, useState } from "react";
import style from "../TablesAndFiguresMenus.module.scss";
import { isNullOrEmpty } from "../../../utils/isNullOrEmpty";
import useActiveTopicBrowserHistory from "../../../hooks/useActiveTopicBrowserHistory";

const GuidelineFigures = () => {
  const navigate = useNavigate();
  const dartMap = useSelector(selectMap);
  const {updateBrowserHistoryOfActiveTopic} = useActiveTopicBrowserHistory()
  const [figureMenus, setFigureMenus] = useState([]);

  const tandfMenus = useMemo(() => {
    return generateTablesAndFigures(dartMap);
  }, [dartMap]);

  useEffect(() => {
    if (!isNullOrEmpty(tandfMenus) && !isNullOrEmpty(tandfMenus.figures)) {
      setFigureMenus(tandfMenus.figures);
    }
  }, [dartMap]);

  const handleClick = (msPath, hrefPath, header) => {
    updateBrowserHistoryOfActiveTopic({msPath, hrefPath, header});
    navigate(msPath);
  };

  return (
    <div className={style.menuItems}>
      {figureMenus.map((props, index) =>{ 
        const id = decodeURIComponent(props.id)
        function clickHandler() {
          handleClick(props.msPath,id, props.title)
        }
           return (
        <div
          className={style.menuItem}
          onClick={clickHandler}
          role="button"
          tabIndex={0}
          aria-label={`Navigate to ${props.title}`}
          key={`item-${index}`}
          id={id}
        >
          <span className={style.label}>{formatMenus(props.title).label}</span>
          <span className={style.description}>{formatMenus(props.title).description}</span>
        </div>
      )})}
    </div>
  );
};

export default GuidelineFigures;
